export const ADD_NEW_CHAT_MESSAGE_SUCCESS = 'ADD_NEW_CHAT_MESSAGE_SUCCESS';

export const addNewChatMessageSuccess = ({ conversation }) => ({
    type: ADD_NEW_CHAT_MESSAGE_SUCCESS,
    payload: {
        conversation,
    },
});
